export default __webpack_public_path__ + "static/059ffc525893660d63d84e5373b28aff.jpeg";